module.exports = __webpack_public_path__ + "static/img/yxms.242b5b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/yxms.png
// module id = ay9C
// module chunks = 1